import ApiService from "@/utils/request";

export const LoginServe = {
  login(
    params = {
      login_name: "admin",
      password: "123456",
    }
  ) {
    return ApiService.post("/dg_admin/v2/login/", params);
  },
  getUserInfo() {
    return ApiService.get("/dg_admin/v2/user_info/");
  },
  getUserType() {
    return ApiService.get("/policy/v2/docking/user_type/");
  },
  getUserStatus() {
    return ApiService.get("/policy/v2/check/check_initial_user/");
  },
  personLogin(params) {
    return ApiService.post("/policy/v2/docking/personal_login/", params);
  },
  legalLogin(params) {
    return ApiService.post("/policy/v2/docking/exchange_token/", params);
  },
  personLogOut() {
    return ApiService.get("https://portal.zjzwfw.gov.cn/uc/logout");
  },
  managerLogin(params) {
    return ApiService.post("/policy/v2/docking/manager_login/", params);
  },
};
